/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Chart': {
    width: 68,
    height: 66,
    viewBox: '0 0 68 66',
    data: '<g transform="translate(3 3)" stroke-width="6" _fill="none" fill-rule="evenodd"><ellipse pid="0" _stroke="#E2E2E2" opacity=".308" cx="31" cy="30" rx="31" ry="30"/><path pid="1" d="M62 30C62 13.431 48.12 0 31 0" _stroke="#E8655D"/></g>'
  }
})
